module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modal-title": 'Edit Field'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Name",
      "validation": "required"
    },
    model: {
      value: (_vm.fieldModel.name),
      callback: function($$v) {
        _vm.$set(_vm.fieldModel, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "fieldModel.name"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "option-groups": _vm.dataTypeOptions,
      "label": "Data Type"
    },
    model: {
      value: (_vm.fieldModel.data_type),
      callback: function($$v) {
        _vm.$set(_vm.fieldModel, "data_type", $$v)
      },
      expression: "fieldModel.data_type"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.fieldTypeOptions,
      "label": "Field Type"
    },
    model: {
      value: (_vm.fieldModel.field_type),
      callback: function($$v) {
        _vm.$set(_vm.fieldModel, "field_type", $$v)
      },
      expression: "fieldModel.field_type"
    }
  }), _vm._v(" "), (_vm.fieldModel.field_type == 'calculated') ? [_c('h5', [_c('b', [_vm._v("Field Value Formula")])]), _vm._v(" "), _c('boolean-expression-widget', {
    attrs: {
      "expression": _vm.fieldModel.formula
    },
    on: {
      "updateExpression": _vm.updateExpression
    }
  })] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfd37544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/FieldModal.vue
// module id = 674
// module chunks = 0